import { CustomIcons, Stack } from '@ltvco/refresh-lib/theme';
import { PillList } from '@ltvco/refresh-lib/v1';
import { FilterTypeOption, type SideMenuItem } from '@ltvco/refresh-lib/v2';
import {
  List,
  FacebookRounded,
  Instagram,
  LinkedIn,
  Pinterest,
  Person,
  Phone,
  Home,
  Email,
  AlternateEmail,
  DirectionsCar,
  Restore,
  Radar,
  Psychology,
  FlareRounded,
  LocalFlorist,
  Redeem,
  RecentActors,
  PieChartOutline,
  NotificationsNone,
  PersonPinCircle,
  DirectionsCarRounded,
  AttachMoney,
  MapRounded,
  Work,
  AccountCircle,
  PersonAdd,
  Summarize,
  Search,
  Lightbulb,
  FamilyRestroom,
  NotificationsActive,
  ManageAccounts,
  X,
  LocalLibraryRounded,
  Gavel,
  AutoAwesomeRounded,
  Notifications,
  Favorite,
  Groups,
  FindInPageOutlined,
  Code,
  FindInPage,
  Business,
  SellOutlined,
  LibraryBooks,
  NightShelter,
  Cottage,
} from '@mui/icons-material';

import { BVLogo } from 'icons';
import imgAncestorIcon from 'images/ancestor-icon.svg';
import aquarius from 'images/ast-aquarius.svg';
import aries from 'images/ast-aries.svg';
import cancer from 'images/ast-cancer.svg';
import capricorn from 'images/ast-capricorn.svg';
import compatibilityImg from 'images/ast-compatibility.svg';
import empty from 'images/ast-empty.png';
import gemini from 'images/ast-gemini.svg';
import leo from 'images/ast-leo.svg';
import libra from 'images/ast-libra.svg';
import emptyBackground from 'images/ast-numerology.svg';
import pisces from 'images/ast-pisces.svg';
import sagittarius from 'images/ast-sagittarius.svg';
import scorpio from 'images/ast-scorpio.svg';
import smallAquarius from 'images/ast-small-aquarius.svg';
import smallAries from 'images/ast-small-aries.svg';
import smallAscendant from 'images/ast-small-ascendant.svg';
import smallCancer from 'images/ast-small-cancer.svg';
import smallCapricorn from 'images/ast-small-capricorn.svg';
import smallGemini from 'images/ast-small-gemini.svg';
import smallLeo from 'images/ast-small-leo.svg';
import smallLibra from 'images/ast-small-libra.svg';
import smallPisces from 'images/ast-small-pisces.svg';
import smallSagittarius from 'images/ast-small-sagittarius.svg';
import smallScorpio from 'images/ast-small-scorpio.svg';
import smallTaurus from 'images/ast-small-taurus.svg';
import smallVirgo from 'images/ast-small-virgo.svg';
import taurus from 'images/ast-taurus.svg';
import virgo from 'images/ast-virgo.svg';
import imgBellCurveNull from 'images/bell-curve-null.svg';
import imgBellCurve from 'images/bell-curve.svg';
import bvLogoPng from 'images/bv_logo_png.png';
import imgFamilyAlbumEmpty from 'images/family-album-empty.svg';
import imgFamilyTreeCameraIcon from 'images/family-tree-camera-icon.svg';
import imgFamilyTreeCloudUploadIcon from 'images/family-tree-cloud-upload-icon.svg';
import imgFamilyTreeDeathIndexIcon from 'images/family-tree-death-index-icon.svg';
import imgFamilyTreePhotoPlaceholderIcon from 'images/family-tree-photo-placeholder-icon.svg';
import imgFamilyTreeViewDocument from 'images/family-tree-view-document.svg';
import group2Icon from 'images/group-2.svg';
import imgIdMonitorShieldBlue from 'images/id-monitor-shield-blue.svg';
import imgAccidentsIcon from 'images/img-accidents-icon.svg';
import imgDamagesIcon from 'images/img-damages-icon.svg';
import imgFamilyTreeOnboardingFinished from 'images/img-family-tree-onboarding-finished.svg';
import imgImpoundsIcon from 'images/img-impounds-icon.svg';
import imgLiensIcon from 'images/img-liens-icon.svg';
import imgRepairQuoteVehicle from 'images/img-repair-quote-vehicle.svg';
import imgRepairsIcon from 'images/img-repairs-icon.svg';
import imgSalvagesIcon from 'images/img-salvages-icon.svg';
import imgTitleBrandsIcon from 'images/img-title-brands-icon.svg';
import imgTitleRecordsIcon from 'images/img-title-records-icon.svg';
import imgCreateList from 'images/img_create_list.svg';
import imgFamilySearchAncestor from 'images/img_family_search_ancestor.svg';
import imgMigrationCta from 'images/img_migration_cta.svg';
import imgNameHistorySearch from 'images/img_name_history_search.png';
import imgUnclaimedMoneyBannerLogo from 'images/img_unclaimed_money_banner_logo.png';
import imgCreateFamilyMemberIcon from 'images/imgMemberCreator.svg';
import imgNotificationBanner from 'images/notifications-banner.png';
import reactivationFireIcon from 'images/reactivation-fire-icon.svg';
import reactivationLock from 'images/reactivation-lock.svg';
import reactivationMembershipIcon from 'images/reactivation-membership-icon.svg';
import reactivationSwitchPlanIcon from 'images/reactivation-switch-plan-icon.svg';
import imgVerticalArrowNull from 'images/vertical-arrow-null.svg';
import imgVerticalArrow from 'images/vertical-arrow.svg';
import { LEGAL_INTELLIGENCE_ROUTES } from 'routes/Dashboard/CourtCases/constants';

import personalityTraitsLoading from './animations/personality-traits-loading.json';
import imgAddVehicle from './images/add-vehicle.svg';
import imgAiFamilyPhotosBannerIcon from './images/ai-family-photos-banner-icon.svg';
import imgAncestorReportFamilyIcon from './images/ancestor-report-family.svg';
import imgAnimatedPersonMagnifying from './images/ani_person_magnifying.gif';
import imgAstrologyStandAloneOnboarding from './images/ast-standalone-onboarding-bg.svg';
import AstrologyIcon from './images/astrology-icon.svg';
import imgToggleToSatellite from './images/btn-map-satellite.png';
import imgToggleToStreet from './images/btn-map-street.png';
import bvMobileBannerIcon from './images/bv-mobile-banner-icon.svg';
import imgCakeRounded from './images/cake-rounded.svg';
import imgCampaign from './images/campaign.svg';
import cancelDownsellBackgroundMobile from './images/cancel-downsell-bg-mobile.svg';
import cancelDownsellBackground from './images/cancel-downsell-bg.svg';
import imgChristmasClaymationFullFamilyPhoto from './images/christmas_full.png';
import downsellModalBackground from './images/Circle-gradient-bg.svg';
import imgClock from './images/clock.svg';
import imgColonialTimes from './images/colonial-times.png';
import imgColonialTimesFullFamilyPhoto from './images/colonial_full.png';
import colorBar from './images/color-bar.svg';
import imgColorizeYourPhoto from './images/colorize-your-photo.png';
import imgContactSearchRightArrow from './images/contact-search-right-arrow.svg';
import imgCurrentOwner from './images/current-owner-icon.svg';
import imgDefaultContactSearchMessage from './images/default-contact-search-message.svg';
import imgDevice from './images/device.svg';
import deviceLoaderGif from './images/device_loader.gif';
import DigitalIdentityLogo from './images/digital-id-logo.svg';
import imgDiscountTag from './images/discount-tag.svg';
import imgDollar from './images/dollar.svg';
import doNotLoseAccess from './images/doNotLoseAccess.svg';
import downSellCancelModalIcon from './images/downsell-cancel-modal-icon.svg';
import downsellSpecialOfferImg from './images/downsellSpecialOffer.svg';
import earthquakeIcon from './images/earthquake.svg';
import imgEmission from './images/emission.svg';
import errorComputer from './images/error-computer.svg';
import imgFamilySearchIcon from './images/family-search-icon.svg';
import imgFamilySearchTreeIcon from './images/family-search-tree-icon.svg';
import imgFamilySearch from './images/family-search.svg';
import imgFamilyTreeAddRelative from './images/family-tree-add-relative.svg';
import imgFamilyTreeAILogo from './images/family-tree-ai-logo.svg';
import imgFamilyTreeBackground from './images/family-tree-background.svg';
import imgFamilyTreeDeceased from './images/family-tree-deceased.svg';
import imgFamilyTreeMainDetails from './images/family-tree-main-details-img.svg';
import imgFamilyTreeNames from './images/family-tree-names-img.svg';
import imgFamilyTreeOriginalMember from './images/family-tree-original-member.svg';
import imgFamilyTreePetIcon from './images/family-tree-pet-icon.svg';
import imgFamilyTreePlaceholder from './images/family-tree-placeholder.svg';
import imgFamilyTreeSearch from './images/family-tree-search-img.svg';
import imgFamilyTreeStarsIcon from './images/family-tree-stars-icon.svg';
import imgFamilyTreeBuilderBlue from './images/family-tree-tree-builder-blue.svg';
import imgFamilyTreeBuilder from './images/family-tree-tree-builder.svg';
import imgFamilyTree from './images/family-tree-tree-img.svg';
import imgFlowerObituary from './images/flowerObituary.svg';
import fourMainPersonalityTypesMobile from './images/four-main-personality-types-mobile.svg';
import fourMainPersonalityTypes from './images/four-main-personality-types.svg';
import imgHalloweenFullFamilyPhoto from './images/halloween_full.png';
import imgCheckList from './images/icn_img_checklist.svg';
import imgIdHub from './images/id-hub.svg';
import imgAiFamilyPhotosDashboardBanner from './images/img-ai-photos-banner.svg';
import ComplianceLogo from './images/img-alert.svg';
import imgAppleStore from './images/img-appstore.svg';
import imgCheckIcon from './images/img-check-icon.svg';
import imgChristmasClaymation from './images/img-christmas-claymation-ai-photo.png';
import imgCloseIcon from './images/img-close-icon.svg';
import imgCrestAIPhotoBannerFullWidth from './images/img-crest-ai-photo-banner-full-width.png';
import imgCrestAIPhotoBanner from './images/img-crest-ai-photo-banner.png';
import imgCrestAIPhoto from './images/img-crest-ai-photo.png';
import imgCrimeFeedCTA from './images/img-crime-feed-cta.svg';
import imgDarkWebEmail from './images/img-dark-web-email.svg';
import personalityTraitsModalDots from './images/img-dots.svg';
import imgEmailSearchGraphic from './images/img-email-search.svg';
import imgEmptyMonitoredReports from './images/img-empty-monitored-reports.svg';
import imgEmptyNotifications from './images/img-empty-notifications.svg';
import imgEmptySavedLists from './images/img-empty-saved-lists.svg';
import imgEmptySavedSearches from './images/img-empty-saved-searches.svg';
import imgFamilyVoyageBanner from './images/img-family-voyage-banner.png';
import imgGoogleStore from './images/img-google-play.svg';
import imgHalloween from './images/img-halloween-ai-photo.svg';
import imgPremiumFrame from './images/img-premium-frame.svg';
import imgPremiumSearchIcon from './images/img-premium-search-icon.svg';
import personalityTraitsModal from './images/img-pt-modal-header.png';
import imgRadialCar from './images/img-radial-car.svg';
import imgRadialProperty from './images/img-radial-property.svg';
import searchpal from './images/img-searchpal.svg';
import imgThanksgivingParade from './images/img-thanksgiving-ai-photo.svg';
import img24hr from './images/img_24hr.svg';
import imgAddressGeneric from './images/img_address_generic_no_bg.svg';
import imgAiCrimeError from './images/img_ai_crime_error.svg';
import imgAiCrimeLoadingAnimation from './images/img_ai_crime_loading_animation.gif';
import imgAiSearch from './images/img_ai_search.svg';
import imgAmenities from './images/img_amenities.svg';
import american_express from './images/img_amex.svg';
import imgAppStoreBadge from './images/img_apple_app_store_badge.svg';
import applePay from './images/img_apple_pay.svg';
import imgAreaPin from './images/img_areapin.svg';
import imgAstrologyNumerology from './images/img_astrology_numerology.svg';
import imgAstrologyNumerologyLoading from './images/img_astrology_numerology_loading.svg';
import imgAstrologyNumerologyV2 from './images/img_astrology_numerology_v2.svg';
import imgAttachmentJpg from './images/img_attachment_jpg.svg';
import imgAttachmentPdf from './images/img_attachment_pdf.svg';
import imgGooglePlayBadge from './images/img_badge_google_play.svg';
import imgBell from './images/img_bell.svg';
import imgMonitoringBell from './images/img_bell_monitoring.svg';
import imgBrazilFlag from './images/img_brazil_flag.svg';
import imgCircleUser from './images/img_circle_user.svg';
import imgCloudDocumentLockBox from './images/img_cloud_document_lockbox.svg';
import imgCloudUpload from './images/img_cloud_upload.svg';
import imgComputerLimitReached from './images/img_computer_limit_reached.svg';
import imgContactlessIcon from './images/img_contactless_icon.svg';
import imgCopyIcon from './images/img_copy_icon.svg';
import imgCrimeCompareNoData from './images/img_crime_compare_no_data.svg';
import imgCrimeWatch from './images/img_crime_watch.svg';
import imgCustomerService from './images/img_customer_service.svg';
import imgDarkWebScan from './images/img_dark_web_scan.svg';
import imgDashBell from './images/img_dash_bell.svg';
import imgDashFraud from './images/img_dash_fraud.svg';
import imgDashHacker from './images/img_dash_hacker.svg';
import imgDashId from './images/img_dash_id.svg';
import imgDashMoney from './images/img_dash_money.svg';
import imgDashPrize from './images/img_dash_prize.svg';
import imgDashUser from './images/img_dash_user.svg';
import discover from './images/img_discover.svg';
import imgEllipsePin from './images/img_ellipse_pin.svg';
import imgEtagsLogo from './images/img_etags_logo.svg';
import imgExampleAircraft from './images/img_example_aircraft.svg';
import imgExampleAutomobile from './images/img_example_automobile.svg';
import imgExampleWatercraft from './images/img_example_watercraft.svg';
import imgExpiredEmailLink from './images/img_expired_email_link.svg';
import imgFallbackProperty from './images/img_fallback_property.svg';
import imgFraudCheck from './images/img_fraud_check.svg';
import genericCreditCard from './images/img_generic_credit_card.svg';
import imgGlobalDocumentLockBox from './images/img_global_attachment.svg';
import googlePay from './images/img_google_pay.svg';
import imgInfinity from './images/img_infinity.svg';
import imgIntellectualProperty from './images/img_intellectual_property.png';
import imgLegalIntelBottom from './images/img_legal_intel_bottom.svg';
import imgLegalIntelBottomMobile from './images/img_legal_intel_bottom_mobile.svg';
import imgLegalIntelTop from './images/img_legal_intel_top.svg';
import imgLegalIntelTopMobile from './images/img_legal_intel_top_mobile.svg';
import imgMagnifyingGlassNoResultsPage from './images/img_magnifying_glass_no_results.svg';
import imgMailBox from './images/img_mailbox.svg';
import imgMapDefaultPin from './images/img_map_default_pin.png';
import imgMapMainHomePin from './images/img_map_main_home_pin.svg';
import imgMapPinBlue from './images/img_map_pin_blue.svg';
import imgMapSecondaryPin from './images/img_map_secondary_pin.svg';
import imgMarketTrends from './images/img_market_trends.svg';
import masterCard from './images/img_mastercard.svg';
import imgMobileExpIcon from './images/img_mobile_exp_icon.svg';
import imgMobileFreemium from './images/img_mobile_freemium.svg';
import imgMyAccountVin from './images/img_myaccount_vin.svg';
import imgMyGarageBrake from './images/img_mygarage_brake.svg';
import imgMyGarageOilChange from './images/img_mygarage_oilchange.svg';
import imgMyGarageSellYourCar from './images/img_mygarage_sellyourcar.svg';
import imgMyGarageStar from './images/img_mygarage_starfilled.svg';
import imgMyGarageTireChange from './images/img_mygarage_tirechange.svg';
import imgMyGarageTitleCheck from './images/img_mygarage_titlecheck.svg';
import imgNHFacts from './images/img_neighborhood_facts.svg';
import imgMonitorBanner from './images/img_neighborhood_safety.svg';
import imgNMVTISLogo from './images/img_nmvtis_logo.svg';
import imgNoticeLeave from './images/img_notice_leave.svg';
import paymentRequired from './images/img_payment_required.svg';
import paymentRequiredV2 from './images/img_payment_required_v2.svg';
import paypal from './images/img_paypal.svg';
import img_pdf_document from './images/img_pdf_document.svg';
import img_pdf_glow from './images/img_pdf_glow.svg';
import imgPersonSearch from './images/img_person_search.svg';
import imgMapBoxPin from './images/img_pin.svg';
import imgPlaceholderSexOffender from './images/img_placeholder_sex_offender.svg';
import imgPremiumBadge from './images/img_premium_badge.svg';
import imgReceiptsFile from './images/img_receipts_file.svg';
import imgReceiptsFileMobile from './images/img_receipts_file_mobile.svg';
import imgReferralsIcon from './images/img_referrals_icon.svg';
import imgReportRating from './images/img_report_rating.svg';
import imgSaveListProperty from './images/img_save_list_property.svg';
import imgSingleTree from './images/img_single_tree.svg';
import beenverifiedLogo from './images/img_social_beenverified.svg';
import facebookLogo from './images/img_social_facebook.svg';
import instagramLogo from './images/img_social_instagram.svg';
import linkedinLogo from './images/img_social_linkedin.svg';
import pinterestLogo from './images/img_social_pinterest.svg';
import twitterLogo from './images/img_social_twitter.svg';
import imgSpainFlag from './images/img_spain_flag.svg';
import imgSingleSignOnCta from './images/img_sso_cta.svg';
import img_success_check from './images/img_success_check.svg';
import imgSuccessfulUpgrade from './images/img_successful_upgrade.svg';
import imgTitleChecks from './images/img_title_checks.svg';
import imgTitleRegistration from './images/img_title_registration.svg';
import imgTreeOfLife from './images/img_tree_of_life.svg';
import imgUpdatesIcon from './images/img_updates_icon.svg';
import imgUploadAttachmentIcon from './images/img_upload_attachment_icon.svg';
import imgUSflag from './images/img_usa_flag.svg';
import venmo from './images/img_venmo.svg';
import venmoButton from './images/img_venmo_button.svg';
import visa from './images/img_visa.svg';
import imgWhatIsAVin from './images/img_what_is_a_vin.svg';
import imgWhatIsAVinV2 from './images/img_what_is_a_vin_v2.svg';
import imgWhereIsVin from './images/img_where_is_vin.svg';
import imgWhereIsVinV2 from './images/img_where_is_vin_v2.svg';
import Bankrupticies from './images/imgBankruptcies.svg';
import ClaimedReport from './images/imgClaimedReport.svg';
import ClaimReport from './images/imgClaimReport.svg';
import Criminal from './images/imgCriminal.svg';
import imgDarkWebSection from './images/imgDarkWebSection.svg';
import MonitoringBell from './images/imgMonitoringBell.svg';
import imgObituarySearchGraphic from './images/imgObituarySearchGraphic.svg';
import imgPoweredByGoogleTranslate from './images/imgPoweredGoogleTranslate.svg';
import Traffic from './images/imgTraffic.svg';
import landslideIcon from './images/landslide.svg';
import logoSmall from './images/logo-small.svg';
import logo from './images/logo.svg';
import imgFamilyTreeMapBackground from './images/map-background.svg';
import imgFamilyTreeMapDeceseased from './images/map-deceased.svg';
import imgFamilyTreeMapPinMarker from './images/map-pin-marker.svg';
import imgFamilyTreeMapPin from './images/map-pin.svg';
import imgMountRushmoreFamilyPhoto from './images/mount-rushmore-family-photo.png';
import imgMultiSearchClipboard from './images/multi-search-clipboard.svg';
import myGarageCtaImage from './images/my_garage_cta_image.svg';
import neighborSpoofing from './images/neighbor-spoofing.svg';
import imgNeighborhoodBgSearch1 from './images/neighborhood-bg-search-1.svg';
import imgNeighborhoodBgSearch2 from './images/neighborhood-bg-search-2.svg';
import imgNeighborhoodInsightsBanner from './images/neighborhood-insights-banner.svg';
import imgDataCollectionsEmptyCard from './images/no-collections.svg';
import imgNoContactResultsFound from './images/no-contact-results-found.svg';
import imgImmediateFamilyEmptyCard from './images/no-immediate-family.svg';
import imgLifeEventEmptyCard from './images/no-life-events.svg';
import imgNoProperty from './images/no-property-img-fallback.svg';
import imgNoRelativesListed from './images/no-relatives-listed.svg';
import imgNoVehicleImageProvided from './images/no-vehicle-image-provided.svg';
import ownerSearchGenericCta from './images/owner-search-generic-cta.svg';
import imgPartialAddressIdCardIcon from './images/partial-address-id-card-icon.svg';
import imgPartialAddressLockIcon from './images/partial-address-lock-icon.svg';
import personalityColorBanner from './images/personality-color-banner.svg';
import personalityColorBar from './images/personality-color-bar.svg';
import personalityTraitType from './images/personality-trait-type.svg';
import agreeableness from './images/personality-traits-agreeableness.svg';
import analyst from './images/personality-traits-analyst.svg';
import compliance from './images/personality-traits-compliance.svg';
import conscientiousness from './images/personality-traits-conscientiousness.svg';
import diplomats from './images/personality-traits-diplomat.svg';
import dominance from './images/personality-traits-dominance.svg';
import explorers from './images/personality-traits-explorer.svg';
import extraversion from './images/personality-traits-extraversion.svg';
import influence from './images/personality-traits-influence.svg';
import personalityTraitsLogo from './images/personality-traits-logo.svg';
import neuroticism from './images/personality-traits-neuroticism.svg';
import openness from './images/personality-traits-openness.svg';
import sentinels from './images/personality-traits-sentinel.svg';
import stability from './images/personality-traits-stability.svg';
import imgPetCreator from './images/pet-creator.svg';
import premiumModalBannerMob1 from './images/premiumModal-banner-mob1.svg';
import premiumModalBannerMob2 from './images/premiumModal-banner-mob2.svg';
import premiumModalBanner from './images/premiumModal-banner.svg';
import premiumModalCrown from './images/premiumModal-crown.svg';
import premiumModalPersonIcon from './images/premiumModal-person.svg';
import premiumModalPhoneIcon from './images/premiumModal-phone.svg';
import premiumModalPropertyIcon from './images/premiumModal-property.svg';
import imgRelativesQuickAdd from './images/relatives_quick_add.svg';
import imgRelativesSearch from './images/relatives_search.svg';
import RewardsBannerBg from './images/rewards-banner-bg.png';
import RewardsBanner from './images/rewards-banner.svg';
import RewardsLogo from './images/rewards-logo.svg';
import rewardsBannerDesktop from './images/rewards_banner_desktop.png';
import rewardsBannerMobile from './images/rewards_banner_mobile.png';
import rewardsCtaImage from './images/rewards_cta_image.svg';
import imgRocket from './images/rocket.svg';
import imgMountRushmoreFullFamilyPhoto from './images/rushmore_full.png';
import imgSafety from './images/safety.svg';
import savedSearchesEmptyStateIcon from './images/saved-searches-empty-state-icon.svg';
import imgSchoolsNearbyEmptyState from './images/schools-nearby-empty-state.svg';
import searchIcon from './images/search-icon.svg';
import SearchLogo from './images/search-logo.svg';
import imgSeverityCritical from './images/severity-critical.svg';
import imgSeverityHigh from './images/severity-high.svg';
import imgSeverityLow from './images/severity-low.svg';
import imgSeverityMedium from './images/severity-medium.svg';
import imgSeverityNone from './images/severity-none.svg';
import imgShieldBlockIcon from './images/shield-block-icon.svg';
import imgShieldCheckIcon from './images/shield-check-icon.svg';
import imgSpecializedBackgroundCheck from './images/specialized-background-check.svg';
import imgSpecializedUnclaimedMoney from './images/specialized-unclaimed-money.svg';
import timPhoto from './images/sponsored-agent-photo-tim.png';
import yingPhoto from './images/sponsored-agent-photo-ying.png';
import generalPhoto from './images/sponsored-agent-photo.png';
import staypalOnline from './images/staypal-online.svg';
import staypal from './images/staypal.svg';
import imgThanksgivingFullFamilyPhoto from './images/thanksgiving_full.png';
import imgTimelessFamilyPhoto from './images/timeless-family-photo.png';
import trustPilotIcon from './images/trustpilot.svg';
import ukLogo from './images/UK-logo.svg';
import imgUpdatePaymentDetails from './images/update-payment-details.svg';
import upgradeLimit from './images/upgrade-limit.svg';
import verificationEmail from './images/verification-email.svg';
import wildfireIcon from './images/wildfire.svg';
import {
  internationalPhoneFraudSearchLocale,
  internationalPhoneFraudSearchPopularCountryCodes,
  internationalPhoneSearchLocale,
  internationalPhoneSearchPopularCountryCodes,
} from './internationalPhoneInputConfig';

const baseUrl = `${window.location.protocol}//${window.location.host}`;
const reportTypeFilterOptions: { [key: string]: FilterTypeOption } = {
  detailed_person_report: {
    id: 'detailed_person_report',
    display: 'Person',
    eventLabel: 'Person',
  },
  reverse_phone_report: {
    id: 'reverse_phone_report',
    display: 'Phone',
    eventLabel: 'Phone',
  },
  property_report: {
    id: 'property_report',
    display: 'Property',
    eventLabel: 'Property',
  },
  vehicle_report: {
    id: 'vehicle_report',
    display: 'Vehicle',
    eventLabel: 'Vehicle',
  },
  social_network_report: {
    id: 'social_network_report',
    display: 'Email',
    eventLabel: 'Email',
  },
  username_report: {
    id: 'username_report',
    display: 'Username',
    eventLabel: 'Username',
  },
  sex_offender_report: {
    id: 'sex_offender_report',
    display: 'Neighborhood',
    eventLabel: 'Neighborhood',
  },
  obituary_report: {
    id: 'obituary_report',
    display: 'Obituary',
    eventLabel: 'Obituary',
  },
  ancestry_report: {
    id: 'ancestry_report',
    display: 'Ancestor',
    eventLabel: 'Ancestor',
  },
  unclaimed_money_report: {
    id: 'unclaimed_money_report',
    display: 'Unclaimed Money',
    eventLabel: 'Unclaimed Money',
  },
  contact_report: {
    id: 'contact_report',
    display: 'Contact Pro',
    eventLabel: 'Contact',
  },
  phone_fraud_report: {
    id: 'phone_fraud_report',
    display: 'Phone Fraud',
    eventLabel: 'Phone Fraud',
  },
  email_fraud_report: {
    id: 'email_fraud_report',
    display: 'Email Fraud',
    eventLabel: 'Email Fraud',
  },
  ip_fraud_report: {
    id: 'ip_fraud_report',
    display: 'IP Fraud',
    eventLabel: 'IP Fraud',
  },
  url_fraud_report: {
    id: 'url_fraud_report',
    display: 'URL Fraud',
    eventLabel: 'Url Fraud',
  },
  fam_death_index_report: {
    id: 'fam_death_index_report',
    display: 'Death Index',
    eventLabel: 'Death Index',
  },
  fam_divorce_index_report: {
    id: 'fam_divorce_index_report',
    display: 'Divorce Index',
    eventLabel: 'Divorce Index',
  },
  fam_census_report: {
    id: 'fam_census_report',
    display: 'Census',
    eventLabel: 'Census',
  },
  fam_marriage_index_report: {
    id: 'fam_marriage_index_report',
    display: 'Marriage Index',
    eventLabel: 'Marriage Index',
  },
  fam_birth_index_report: {
    id: 'fam_birth_index_report',
    display: 'Birth Index',
    eventLabel: 'Birth Index',
  },
  fam_military_index: {
    id: 'fam_military_index_report',
    display: 'Military Records',
    eventLabel: 'Military Records',
  },
  fam_immigration_index_report: {
    id: 'fam_immigrants_index_report',
    display: 'Immigration Records',
    eventLabel: 'Immigration Records',
  },
  fam_social_security_index_report: {
    id: 'fam_social_security_index_report',
    display: 'Social Security Records',
    eventLabel: 'Social Security Records',
  },
};

// TODO: should we extend the default config the same way we're doing with the theme? might be good for some props, other props maybe should be required
export const constants = {
  images: {
    imgClaimReport: ClaimReport,
    imgDarkWebSection,
    imgClaimedReport: ClaimedReport,
    imgMonitoring: MonitoringBell,
    brandLogo: logo,
    brandLogoMobile: logoSmall,
    UKBrandLogo: ukLogo,
    imgRewardsLogo: RewardsLogo,
    imgRewardsBanner: RewardsBanner,
    imgRewardsBannerBg: RewardsBannerBg,
    imgDigitalIdentityLogo: DigitalIdentityLogo,
    imgAppleStore,
    imgGoogleStore,
    master: masterCard,
    visa,
    american_express,
    discover,
    genericCreditCard,
    paypal,
    googlePay,
    paymentRequired,
    paymentRequiredV2,
    doNotLoseAccess,
    applePay,
    venmo,
    venmoButton,
    searchLogo: SearchLogo,
    complianceLogo: ComplianceLogo,
    imgDarkWebEmail,
    imgNoProperty,
    imgExampleAircraft,
    imgExampleWatercraft,
    imgExampleAutomobile,
    monitoringBell: imgMonitoringBell,
    imgIdHub,
    imgAddressGeneric,
    imgBell,
    imgDarkWebScan,
    imgSpecializedBackgroundCheck,
    imgSpecializedUnclaimedMoney,
    imgReportRating,
    imgSuccessfulUpgrade,
    imgComputerLimitReached,
    pdfLogo: img_pdf_glow,
    pdfDocumentIcon: img_pdf_document,
    successCheckIcon: img_success_check,
    img24hr,
    neighborSpoofing,
    imgAnimatedPersonMagnifying,
    deviceLoaderGif,
    imgMagnifyingGlassNoResultsPage,
    imgMapDefaultPin,
    imgMapMainHomePin,
    imgMapSecondaryPin,
    imgMapPinBlue,
    imgMonitorBanner,
    imgMobileExpIcon,
    imgCopyIcon,
    imgContactlessIcon,
    imgUpdatesIcon,
    imgEtagsLogo,
    imgAddVehicle,
    imgNHFacts,
    imgMarketTrends,
    imgAmenities,
    imgWhereIsVin,
    imgMyAccountVin,
    imgWhereIsVinV2,
    imgWhatIsAVin,
    imgWhatIsAVinV2,
    imgIntellectualProperty,
    imgLegalIntelTop,
    imgLegalIntelTopMobile,
    imgLegalIntelBottom,
    imgLegalIntelBottomMobile,
    imgCheckList,
    imgAppStoreBadge,
    imgGooglePlayBadge,
    imgMobileFreemium,
    imgFraudCheck,
    downSellCancelModalIcon,
    bvMobileBannerIcon,
    ownershipHistoryImages: {
      imgCircleUser,
    },
    recallImages: {
      imgSeverityCritical,
      imgSeverityHigh,
      imgSeverityLow,
      imgSeverityMedium,
      imgSeverityNone,
      imgClock,
      imgDollar,
      imgEmission,
      imgSafety,
      imgCampaign,
    },
    imgPremiumBadge,
    imgTitleRegistration,
    imgTitleChecks,
    accidentsCoverageMapImage:
      'https://bv-content.beenverified.com/fit-in/980x0/filters:format(png)/filters:quality(60)/accident_coverage_map.png',
    rewardsBannerMobile,
    rewardsBannerDesktop,
    myGarageCtaImage,
    rewardsCtaImage,
    imgFallbackSexOffender: imgPlaceholderSexOffender,
    verificationEmail,
    imgMapBoxPin,
    imgAreaPin,
    imgMailBox,
    imgReferralsIcon,
    imgCustomerService,
    imgExpiredEmailLink,
    imgFallbackProperty,
    imgPlaceholderSexOffender,
    imgNoVehicleImageProvided,
    imgDashMoney,
    imgDashBell,
    imgDashHacker,
    imgDashId,
    imgDashPrize,
    imgDashUser,
    imgDashFraud,
    imgNoticeLeave,
    imgMyGarage: {
      imgMyGarageBrake,
      imgMyGarageOilChange,
      imgMyGarageSellYourCar,
      imgMyGarageStar,
      imgMyGarageTireChange,
      imgMyGarageTitleCheck,
    },
    imgGarageNavEstimatedValue: imgAccidentsIcon,
    imgGarageNavRecalls: imgIdMonitorShieldBlue,
    imgGarageNavWarranties: imgImpoundsIcon,
    nmvtisLogo: imgNMVTISLogo,
    imgToggleToSatellite,
    imgToggleToStreet,
    imgPerksBanner: rewardsBannerDesktop,
    imgPerksBannerMob: rewardsBannerMobile,
    imgSchoolsNearbyEmptyState,
    imgRadialCar,
    imgDefaultContactSearchMessage,
    imgNoContactResultsFound,
    imgContactSearchRightArrow,
    imgSaveListProperty,
    imgPremiumData: {
      imgPremiumFrame,
      imgPremiumSearchIcon,
      imgCheckIcon,
      imgCloseIcon,
    },
    imgFlowerObituary,
    imgCakeRounded,
    imgEmailSearchGraphic,
    familyTreeImages: {
      imgAncestorIcon,
      imgRelativesQuickAdd,
      imgPetCreator,
      imgRelativesSearch,
      imgFamilyTreeBackground,
      imgFamilyTreePlaceholder,
      imgFamilyTreeAddRelative,
      imgFamilyTreeDeceased,
      imgFamilyTreePetIcon,
      imgFamilyTreeOriginalMember,
      imgFamilyTreeMapBackground,
      imgFamilyTreeMapPin,
      imgFamilyTreeMapDeceseased,
      imgFamilyTreeSearch,
      imgFamilyTree,
      imgFamilyTreeNames,
      imgFamilyTreeMainDetails,
      imgFamilyTreeMapPinMarker,
      imgFamilySearchIcon,
      imgFamilySearchTreeIcon,
      imgFamilyTreeBuilder,
      imgFamilyTreeBuilderBlue,
      imgFamilyTreeAILogo,
      imgFamilyTreeStarsIcon,
      imgFamilySearch,
      imgFamilyTreeCameraIcon,
      imgFamilyTreeCloudUploadIcon,
      imgFamilyTreePhotoPlaceholderIcon,
      imgFamilyAlbumEmpty,
      brandLogoPng: bvLogoPng,
      imgFamilyTreeViewDocument,
      imgCreateFamilyMemberIcon,
      imgFamilyTreeDeathIndexIcon,
      imgFamilyTreeOnboardingFinished,
      imgAiFamilyPhotosBannerIcon,
      imgTimelessFamilyPhoto,
      imgMountRushmoreFamilyPhoto,
      imgMountRushmoreFullFamilyPhoto,
      imgChristmasClaymationFullFamilyPhoto,
      imgHalloweenFullFamilyPhoto,
      imgThanksgivingFullFamilyPhoto,
      imgColorizeYourPhoto,
      imgColonialTimes,
      imgColonialTimesFullFamilyPhoto,
      imgHalloween,
      imgThanksgivingParade,
      imgChristmasClaymation,
      imgNoRelativesListed,
      imgAiFamilyPhotosDashboardBanner,
      imgCrestAIPhoto,
      imgCrestAIPhotoBanner,
      imgCrestAIPhotoBannerFullWidth,
      imgFamilyVoyageBanner,
      imgLifeEventEmptyCard,
      imgDataCollectionsEmptyCard,
      imgImmediateFamilyEmptyCard,
    },
    monitoringCenterImages: {
      imgEmptyNotifications,
      imgEmptySavedSearches,
      imgEmptyMonitoredReports,
      imgEmptySavedLists,
    },
    savedSearchesImages: {
      savedSearchesEmptyStateIcon,
    },
    ancestor: {
      imgAncestorReportFamilyIcon,
    },
    imgTreeOfLife,
    imgSingleTree,
    imgInfinity,
    imgPersonSearch,
    imgRadialProperty,
    astrology: {
      imgAstrologyNumerology,
      imgAstrologyNumerologyV2,
      imgAstrologyNumerologyLoading,
      compatibilityImg,
      aries,
      taurus,
      gemini,
      cancer,
      leo,
      virgo,
      libra,
      scorpio,
      sagittarius,
      capricorn,
      aquarius,
      pisces,
      empty,
      emptyBackground,
      smallAries,
      smallTaurus,
      smallGemini,
      smallCancer,
      smallLeo,
      smallVirgo,
      smallLibra,
      smallScorpio,
      smallSagittarius,
      smallCapricorn,
      smallAquarius,
      smallPisces,
      smallAscendant,
    },
    astrologyStandalone: {
      imgOnboardingBg: imgAstrologyStandAloneOnboarding,
      AstrologyIcon,
    },
    imgRocket,
    premiumModalCrown,
    premiumModalBanner,
    premiumModalBannerMob1,
    premiumModalBannerMob2,
    premiumModalPersonIcon,
    premiumModalPhoneIcon,
    premiumModalPropertyIcon,
    downsellModalBackground,
    downsellSpecialOfferImg,
    fourMainPersonalityTypes,
    fourMainPersonalityTypesMobile,
    personalityColorBanner,
    personalityColorBar,
    colorBar,
    personalityTraitsLogo,
    errorComputer,
    personalityTraitsModal,
    personalityTraitType,
    personalityTraitsModalDots,
    personalityTraits: {
      analyst,
      diplomats,
      explorers,
      sentinels,
      agreeableness,
      conscientiousness,
      extraversion,
      neuroticism,
      openness,
      stability,
      compliance,
      dominance,
      influence,
    },
    sponsoredAgentPhoto: {
      timPhoto,
      yingPhoto,
      generalPhoto,
    },
    imgSingleSignOnCta,
    ownerSearchGenericCta,
    cancelDownsellBackground,
    cancelDownsellBackgroundMobile,
    trustPilotIcon,
    CourtRecordsImages: {
      imgCriminal: Criminal,
      imgTraffic: Traffic,
      imgBankruptcies: Bankrupticies,
    },
    searchpal,
    staypal,
    staypalOnline,
    imgBellCurve,
    imgBellCurveNull,
    imgVerticalArrow,
    imgVerticalArrowNull,
    imgMigrationCta,
    imgUnclaimedMoneyBannerLogo,
    imgNotificationBanner,
    imgFamilySearchAncestor,
    group2Icon,
    reactivationRedesignImages: {
      reactivationFireIcon,
      reactivationMembershipIcon,
      reactivationSwitchPlanIcon,
      reactivationLock,
    },
    imgCreateList,
    damageHistoryIcons: {
      imgAccidentsIcon,
      imgDamagesIcon,
      imgSalvagesIcon,
      imgRepairsIcon,
      imgRepairQuoteVehicle,
    },
    titleHistoryIcons: {
      imgTitleBrandsIcon,
      imgTitleRecordsIcon,
      imgLiensIcon,
      imgImpoundsIcon,
    },
    imgNameHistorySearch,
    searchIcon,
    imgCurrentOwner,
    earthquakeIcon,
    wildfireIcon,
    imgShieldCheckIcon,
    imgShieldBlockIcon,
    imgDevice,
    landslideIcon,
    imgObituarySearchGraphic,
    imgCrimeFeedCTA,
    imgEllipsePin,
    imgCloudUpload,
    imgCrimeWatch,
    imgCloudDocumentLockBox,
    imgGlobalDocumentLockBox,
    imgUploadAttachmentIcon,
    imgAttachmentJpg,
    imgAttachmentPdf,
    translationFlags: {
      imgSpainFlag,
      imgUSflag,
      imgBrazilFlag,
    },
    imgPoweredByGoogleTranslate,
    upgradeLimit,
    neighborhoodReport: {
      imgNeighborhoodBgSearch1,
      imgNeighborhoodBgSearch2,
      imgCrimeCompareNoData,
    },
    imgMultiSearchClipboard,
    imgPropertyBulkUploadPromo: imgMultiSearchClipboard,
    imgPartialAddressLockIcon,
    imgPartialAddressIdCardIcon,
    imgDiscountTag,
    imgUpdatePaymentDetails,
    imgReceiptsFile,
    imgReceiptsFileMobile,
    imgNeighborhoodInsightsBanner,
    imgAiSearch,
    imgAiCrimeLoadingAnimation,
    imgAiCrimeError,
  },
  animations: {
    personalityTraitsLoading,
  },
  links: {
    appsFlyerLink: 'https://beenverified.onelink.me/5mdJ/us28hbjx',
    baseUrl: `${baseUrl}${
      import.meta.env.VITE_PATH_PREFIX?.includes('/')
        ? import.meta.env.VITE_PATH_PREFIX
        : `/${import.meta.env.VITE_PATH_PREFIX}`
    }`,
    joinLink: 'https://www.beenverified.com/lp/32fc4f/4/subscribe',
    brandLink: import.meta.env.VITE_DEV_PROXY_SEARCH_PERSON_TEASER
      ? ''
      : `${baseUrl}`,
    aboutLink: 'https://beenverified.com/about',
    fcraLink: 'https://www.beenverified.com/about/fcra/',
    doDontsLink: 'https://www.beenverified.com/about/dos-donts/',
    tosLink: 'https://www.beenverified.com/faq/terms-conditions/',
    privacyLink: 'https://www.beenverified.com/faq/privacy/',
    contactLink: 'https://www.beenverified.com/contact/',
    FaqLink: 'https://beenverified.com/faq/',
    dontSellInfoLink: 'https://www.beenverified.com/svc/optout/search/optouts',
    affiliateLink: 'https://www.beenverified.com/affiliates',
    peopleSearchLink: 'https://www.beenverified.com/people/',
    reversePhoneLink: 'https://www.beenverified.com/reverse-phone/',
    emailLookupLink: 'https://www.beenverified.com/email-search/',
    reverseAddressLink: 'https://www.beenverified.com/reverse-address-lookup/',
    contactForm: 'https://www.beenverified.com/contact/',
    supportLink: 'http://support.beenverified.com/',
    twitterLink: '',
    facebookLink: '',
    blogLink: '',
    brandIosUrl:
      'https://apps.apple.com/us/app/beenverified-background-check/id342585873?utm_source=beenverified&utm_medium=internal&utm_campaign=',
    brandAndroidUrl:
      'https://play.google.com/store/apps/details?id=com.beenverified.android&hl=en_US&utm_source=beenverified&utm_medium=internal&utm_campaign=',
    rapidsLookupLink: '/rpds/lookup',
    etagsPartnerUrl: 'https://www.etags.com/app/us?utm_source=bv',
    mrRogersBaseUrl: '/ss/mrg',
    billingLink: 'https://www.beenverified.com/faq/billing/',
    customPlanLink:
      'https://docs.google.com/forms/d/e/1FAIpQLSdsuNU5p7oD3CX3VvEMrBP1kvG3AodnhSvDytnb36rDVpcpxg/viewform',
    mapboxStyleUrl: 'mapbox://styles/beenverified/cloywa73e00sd01qnb8162waw',
    dataDeckRootURI: 'hk/dd/v2',
    marketplaceBaseUrl: 'https://www.bumper.com/marketplace/',
    accidentDisclaimerURL:
      'https://support.beenverified.com/hc/en-us/articles/16578808406811',
    chatLink: 'https://www.beenverified.com/chat/',
    vehicleReportInquiryURL:
      'https://www.beenverified.com/contact/vehicle-history-report-inquiry/',

    nmvtisGlossaryURL: 'https://vehiclehistory.bja.ojp.gov/nmvtis_glossary',
    nmvtisStatesURL: 'https://vehiclehistory.bja.ojp.gov/nmvtis_states',
    nmvtisDataProvidersURL:
      'https://vehiclehistory.bja.ojp.gov/nmvtis_vehiclehistory',
    nmvtisVehicleHistoryURL: 'http://vehiclehistory.bja.ojp.gov/',
    topHapBaseUrl: 'https://widgets.tophap.com/api/widgets',
    monocleLeadsEndpoint: 'https://www.beenverified.com/mcl/v1/leads',
    cancelSurveyLink:
      'https://docs.google.com/forms/d/e/1FAIpQLSc7YnY1xB6fOht_hHjVb4jSk2Wh5JpdM7ywEAgdZrkm2ubt8Q/viewform',
    trustPilotReviewUrl:
      'https://www.trustpilot.com/evaluate/www.beenverified.com',
    propertySummaryFeedbackLink:
      'https://docs.google.com/forms/d/e/1FAIpQLScb1X-yqATHYt4_tGltJiziEKmhsk8UmIEW0EDsEyPRwvcoxQ/viewform',
    propertySmartInsightsSurvey: 'https://forms.gle/RyJoGSwCL3xqpr2v6',
    propertyAdvertiseLink: 'https://forms.gle/iBPaZhfMGbSwZpfR9',
    setupSsoLink: 'https://www.beenverified.com/sso_connections',
    neighborhoodInsightsFeedbackLink:
      'https://docs.google.com/forms/d/1941a6A_AhHAczkO9IH1wVn-w2GvaWgjSd2f5Z8f0b74',
    getMostOutRewardsLink: '/dashboard/rewards?tab=rewards',
    fullAddressFormLink:
      'https://docs.google.com/forms/d/e/1FAIpQLSe1Fg_S_hjb6DA_IY3fmZcFnew1vtS2l2UNeGvUnrgVNGt1yg/viewform',
    propertyBulkUploadDashboardPath: '/dashboard/import-list',
    chatAILink: '/deepsearch',
  },
  featureFlags: {
    hasChatBVEnabled: true,
    hasCriminalEnabled: true,
    hasSmartInsightsAutoLoadEnabled: true,
    propertyReportFlags: ['include_ca_data'],
    enableListExport: false,
    familyTreeEnabled: true,
    personReportSummaryEnabled: false,
    obituaryParserEnabled: true,
    familySearchEnabled: true,
    hasConsolidatedSearch: true,
    smartPersonSearchEnabled: true,
    hasReportPreferencesEnabled: true,
    hasMobileSearchHeaderRedesignEnabled: true,
    hasNewMobileHeaderDesignEnabled: true,
    hasShortChatCallout: true,
    shouldOpenNeighborhoodReport: true,
    streamlinedPersonSearchEnabled: true,
    standardHeaderDesignEnabled: true,
    hasCommunityBuzzEnabled: true,
    hasMyGarageBottomResearchVehicleEnabled: true,
    hasCarVettingEnabled: true,
  },
  dataCollections: {
    SSDIRequestEnabled: true,
    census1940Enabled: true,
    // structuredCollections is not listed here on purpose: gdt-search-api owns
    // the catalog now, and CollectionsCatalogProvider supplies it. A copy here
    // is what let the brands drift out of sync in the first place.
  },
  data: {
    brandName: 'BeenVerified',
    brandAbbreviation: 'bv' as 'bv',
    brandSupportEmail: 'support@beenverified.com',
    legalName: 'BeenVerified, LLC',
    supportPhone: '1-844-823-2869',
    customerSupportPhone: '1-888-579-5910',
    supportEmail: 'support@beenverified.com',
    complianceEmail: 'compliance@beenverified.com',
    pdfPrice: '$4.95',
    rewardsDisclaimer:
      'Certain products and services, including vehicle purchase/sale opportunities, provided above include offers from third parties and/or external partners from whom we may receive limited compensation. Please be advised that these offers are provided as a convenience and are a sample, but do not necessarily include ALL offers, products or services available in the marketplace.',
    carGeniusPhone: '1-877-418-2717',
    upgradePlanCustomSolutionHeading: 'Need more reports or users?',
    upgradePlanCustomSolutionDescription: 'Let’s talk',
    limitReachedSubHeading:
      'We offer different solutions to match your search needs',
    contactOptionsCustomPlanDisplay: 'Request larger plan',
    premiumModalCardData: [
      {
        title: 'Person Search',
        icon: premiumModalPersonIcon,
        content:
          'Dive deeper with possible contact information, criminal & address history, etc.',
      },
      {
        title: 'Phone Search',
        icon: premiumModalPhoneIcon,
        content: 'See who might be behind the numbers',
      },
      {
        title: 'Property Search',
        icon: premiumModalPropertyIcon,
        content: 'Discover more about addresses & neighborhoods',
      },
    ],
    premiumModalContent:
      "Looks like you're missing out on key searches, like person search. Unlock premium data for access to person, phone, email, property, dark web, unclaimed money searches and more!",
    validReportCountThreshold: 5,
    plansWithout5ReportBlocker: [
      'Referral_User_0_1_month_freemium_limit3',
      '7_day_trial_1_00_up_front_28_79_recurring_monthly_freshness_limit_100_vin_no_pdf_vehicle_only',
      '7_day_trial_5_00_up_front_28_79_recurring_monthly_freshness_limit_100_vin_free_pdf_vehicle_only',
    ],
    blockUpgradeWindowThreshold: 24,
    smartSearchV1FeedbackLink: 'https://forms.gle/dxxWWFPH326CtnEm8',
    copyrightText:
      '© 2024 BeenVerified, LLC. All rights reserved. BeenVerified® and the BeenVerified star mascot are registered trademarks of BeenVerified, LLC',
    defaultSearchFormEventName: 'openPersonSearch',
    brandCustomerSupportSchedule: {
      days: 'Monday - Friday',
      hours: '9am - 6pm EST',
    },
    customerSupportAvailabilityHours: {
      email: 'Available 24 hours a day',
      chat: 'Chat available 24 hours a day via our AI assistant',
    },
    peopleSubSearches: ['person', 'contact', 'ancestry', 'obituary'],
    nameHistorySeeMoreFlag: true,
    cancelBowtiePlanId: 'CANCEL_BV_01',
    experienceBowtiePlanId: 'EXPERIENCE_BV_01',
    recommendExperienceBowtiePlanId: 'RECOMMEND_EXPERIENCE_BV_01',
    feedbackBowtiePlanId: 'FEEDBACK_BV_01',
    vehicleOnlyUpsellPlans: [
      '7_day_trial_1_00_up_front_32_89_recurring_monthly_freshness_limit_100_vin_no_pdf_vehicle_only',
      '7_day_trial_5_00_up_front_32_89_recurring_monthly_freshness_limit_100_vin_free_pdf_vehicle_only',
      'one_check_29_99_60day_renewal_limit_1_bv_vehicle_only',
    ],
  },
  config: {
    socialMedia: [
      {
        textContent: 'X',
        alternateTextContent: '@BeenVerified',
        href: 'https://x.com/BeenVerified',
        imgLogoUrl: twitterLogo,
        icon: <X fontSize="small" sx={{ color: '#0052FF' }} />,
        hideOnSide: false,
        hideinNeedAssistanceNewDesign: false,
      },
      {
        textContent: 'Facebook',
        alternateTextContent: 'facebook.com/Beenverified',
        href: 'https://www.facebook.com/BeenVerified',
        imgLogoUrl: facebookLogo,
        icon: <FacebookRounded fontSize="small" sx={{ color: '#0052FF' }} />,
        hideOnSide: false,
        hideinNeedAssistanceNewDesign: false,
      },
      {
        textContent: 'Instagram',
        alternateTextContent: 'instagram.com/BeenVerified',
        href: 'https://www.instagram.com/beenverified/',
        imgLogoUrl: instagramLogo,
        icon: <Instagram fontSize="small" sx={{ color: '#0052FF' }} />,
        hideOnSide: true,
        hideinNeedAssistanceNewDesign: false,
      },
      {
        textContent: 'Linkedin',
        alternateTextContent: 'linkedin.com/company/beenverified-com',
        href: 'https://www.linkedin.com/company/beenverified-com',
        imgLogoUrl: linkedinLogo,
        icon: <LinkedIn fontSize="small" sx={{ color: '#0052FF' }} />,
        hideOnSide: true,
        hideinNeedAssistanceNewDesign: false,
      },
      {
        textContent: 'Pinterest',
        href: 'https://www.pinterest.com/beenverified/',
        imgLogoUrl: pinterestLogo,
        icon: <Pinterest fontSize="small" sx={{ color: '#0052FF' }} />,
        hideOnSide: true,
        hideinNeedAssistanceNewDesign: false,
      },
      {
        textContent: 'Beenverified Blog',
        href: 'https://www.beenverified.com/blog/',
        imgLogoUrl: beenverifiedLogo,
        icon: <BVLogo fontSize="medium" color="primary" />,
        hideOnSide: true,
        hideinNeedAssistanceNewDesign: true,
      },
    ],
    searchTabsIndexRecords: [
      {
        displayName: 'Person',
        id: 'peopleTab',
        icon: <Person fontSize="small" />,
        class: 'noBorderBottom noBorderRight',
        internalTabs: [
          {
            label: 'Search By Name',
            mobileLabel: 'Name',
            libFormComponentName: 'SearchPersonForm',
            eventCategory: 'People Search',
          },
          {
            label: 'Search By Address',
            mobileLabel: 'Address',
            libFormComponentName: 'SearchPersonByAddressForm',
            eventCategory: 'Person search by address',
          },
          {
            label: 'Search By Job Title',
            mobileLabel: 'Job Title',
            libFormComponentName: 'SearchContactForm',
            customTrackEvent: {
              category: 'contact search',
              action: 'navigation click',
              label: 'search',
            },
          },
        ],
      },
      {
        displayName: 'Ancestor',
        id: 'ancestorTab',
        icon: <Groups fontSize="small" />,
        class: 'noBorderBottom',
        internalTabs: [
          {
            label: 'Search By Ancestor',
            mobileLabel: 'Ancestor',
            libFormComponentName: 'AncestorSearchForm',
            eventCategory: 'Ancestor Search',
          },
        ],
      },
      {
        displayName: 'Obituary',
        id: 'obituaryTab',
        icon: <LocalFlorist fontSize="small" />,
        class: 'noBorderBottom',
        internalTabs: [
          {
            label: 'Search By Obituary',
            mobileLabel: 'Obituary',
            libFormComponentName: 'ObituarySearchForm',
            eventCategory: 'Obituary Search',
          },
        ],
      },
      {
        displayName: 'Historical Records',
        id: 'historicalRecordsTab',
        icon: <LibraryBooks fontSize="small" />,
        class: 'noBorderBottom',
        internalTabs: [
          {
            label: 'Search Historical Records',
            mobileLabel: 'Historical Records',
            libFormComponentName: 'HistoricalRecordsSearchForm',
            eventCategory: 'Historical Records Search',
          },
        ],
      },
      {
        displayName: 'Vital Records',
        id: 'vitalRecordsTab',
        icon: <Favorite fontSize="small" />,
        class: 'noBorderBottom',
        internalTabs: [
          {
            label: 'Search Vital Records',
            mobileLabel: 'Vital Records',
            libFormComponentName: 'VitalRecordsSearchForm',
            eventCategory: 'Vital Records Search',
          },
        ],
      },
    ],
    searchTabs: [
      {
        displayName: 'People',
        id: 'peopleTab',
        icon: (
          <Person
            fontSize="small"
            sx={{ color: { xs: '#0052FF', md: '#0A0B0D' } }}
          />
        ),
        class: 'noBorderBottom noBorderRight',
        internalTabs: [
          {
            label: 'Search By Name',
            mobileLabel: 'Name',
            libFormComponentName: 'SearchPersonForm',
            eventCategory: 'People Search',
          },
          {
            label: 'Search By Address',
            mobileLabel: 'Address',
            libFormComponentName: 'SearchPersonByAddressForm',
            eventCategory: 'Person search by address',
          },
          {
            label: 'Search By Job Title',
            mobileLabel: 'Job Title',
            libFormComponentName: 'SearchContactForm',
            customTrackEvent: {
              category: 'contact search',
              action: 'navigation click',
              label: 'search',
            },
          },
        ],
      },
      {
        displayName: 'Phone',
        id: 'phoneTab',
        icon: (
          <Phone
            fontSize="small"
            sx={{ color: { xs: '#0052FF', md: '#0A0B0D' } }}
          />
        ),
        class: 'noBorderBottom noBorderRight',
        internalTabs: [
          {
            label: 'Search By Phone Number',
            mobileLabel: 'Phone Number',
            libFormComponentName: 'SearchPhoneForm',
            eventCategory: 'Phone Search',
          },
        ],
      },
      {
        displayName: 'Property',
        id: 'propertyTab',
        icon: (
          <Home
            fontSize="small"
            sx={{ color: { xs: '#0052FF', md: '#0A0B0D' } }}
          />
        ),
        class: 'noBorderBottom',
        internalTabs: [
          {
            label: 'Address Report',
            mobileLabel: 'Report',
            libFormComponentName: 'SearchPropertyForm',
            eventCategory: 'property',
          },
          {
            label: 'Pre-foreclosure',
            mobileLabel: 'Pre-foreclosure',
            libFormComponentName: 'SearchPFCPropertiesForm',
            eventCategory: 'Pre-Foreclosure',
          },
          {
            label: 'Homes For Sale',
            mobileLabel: 'Homes For Sale',
            libFormComponentName: 'SearchForSalePropertiesForm',
            eventCategory: 'Homes For Sale',
          },
          {
            label: 'Short-Term Rentals',
            mobileLabel: 'Short-Term Rentals',
            libFormComponentName: 'SearchShortTermRentalsForm',
            eventCategory: 'Short-Term Rentals',
          },
        ],
      },
      {
        displayName: 'Email',
        id: 'emailTab',
        icon: (
          <Email
            fontSize="small"
            sx={{ color: { xs: '#0052FF', md: '#0A0B0D' } }}
          />
        ),
        class: 'noBorderRight',
        internalTabs: [
          {
            label: 'Search By Email',
            mobileLabel: 'Email',
            libFormComponentName: 'SearchEmailForm',
            eventCategory: 'Email Search',
          },
        ],
      },
      {
        displayName: 'Username',
        id: 'usernameTab',
        icon: (
          <AlternateEmail
            fontSize="small"
            sx={{ color: { xs: '#0052FF', md: '#0A0B0D' } }}
          />
        ),
        class: 'noBorderRight',
        internalTabs: [
          {
            label: 'Search By Username',
            mobileLabel: 'Username',
            libFormComponentName: 'SearchUsernameForm',
            eventCategory: 'Username Search',
          },
        ],
      },
      {
        displayName: 'Vehicle',
        id: 'vehicleTab',
        icon: (
          <DirectionsCar
            fontSize="small"
            sx={{ color: { xs: '#0052FF', md: '#0A0B0D' } }}
          />
        ),
        internalTabs: [
          {
            label: 'VIN',
            mobileLabel: 'VIN',
            libFormComponentName: 'VINSearchForm',
          },
          {
            label: 'License Plate',
            mobileLabel: 'License Plate',
            libFormComponentName: 'LicensePlateSearchForm',
          },
          {
            label: 'Year, Make, Model',
            mobileLabel: 'Year, Make, Model',
            libFormComponentName: 'YMMSearchForm',
          },
        ],
      },
    ],
    fraudScanSearchTabs: [
      {
        displayName: 'Fraud Scan',
        id: 'fraudScanTab',
        icon: <Radar fontSize="small" sx={{ color: '#2E3192' }} />,
        class: 'noBorderBottom noBorderRight',
        internalTabs: [
          {
            label: 'Phone Verification',
            mobileLabel: 'Phone',
            libFormComponentName: 'SearchPhoneFraudForm',
            eventCategory: 'Phone Verification Search',
          },
          {
            label: 'Email Verification',
            mobileLabel: 'Email',
            libFormComponentName: 'SearchEmailFraudForm',
            eventCategory: 'Email Verification Search',
          },
          {
            label: 'Ip Lookup',
            mobileLabel: 'IP',
            libFormComponentName: 'SearchIpFraudForm',
            eventCategory: 'Ip Lookup',
          },
          {
            label: 'URL Scanning',
            mobileLabel: 'URL',
            libFormComponentName: 'SearchURLFraudForm',
            eventCategory: 'URL Scanning',
          },
        ],
      },
    ],
    sideMenuItems: [
      {
        route: '/dashboard',
        icon: <Home sx={{ color: '#0052FF' }} />,
        text: 'My Dashboard',
        name: 'dashboard',
        state: '',
        'data-cy': 'dashboard',
        ga4EventType: 'dashboard',
      },
      {
        route: '/dashboard/reports',
        icon: <Restore sx={{ color: '#0052FF' }} />,
        text: 'Recent Reports',
        name: 'recentReports',
        state: '',
        'data-cy': 'recent_reports',
        ga4EventType: 'recent_reports',
      },
      {
        route: '/dashboard/lists',
        icon: <List sx={{ color: '#0052FF' }} />,
        text: 'Saved Reports and Lists',
        state: '',
        name: 'lists',
        'data-cy': 'saved_reports_and_list',
        ga4EventType: 'lists',
      },
      {
        route: '/dashboard/fraud',
        icon: <Radar sx={{ color: '#0052FF' }} />,
        text: (
          <Stack
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            FraudScan
            <PillList items={[{ label: 'New' }]} />
          </Stack>
        ),
        state: '',
        name: 'fraudScan',
        ga4EventType: 'fraud_scan',
      },
      {
        route: '/dashboard/personality-traits',
        icon: <Psychology sx={{ color: '#0052FF' }} />,
        text: (
          <Stack
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            Personality Traits
            <PillList items={[{ label: 'New' }]} />
          </Stack>
        ),
        state: '',
        name: 'personalityTraits',
        'data-cy': 'personality_traits',
        ga4EventType: 'personality_traits',
      },
      {
        route: '/dashboard/astrology',
        icon: <FlareRounded sx={{ color: '#0052FF' }} />,
        text: (
          <Stack
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            Astrology
            <PillList items={[{ label: 'New' }]} />
          </Stack>
        ),
        state: '',
        name: 'astrology',
        ga4EventType: 'astrology',
      },
      {
        route: '/dashboard/family-ancestry',
        icon: <CustomIcons.FamilyTreeAncestryIcon sx={{ color: '#0052FF' }} />,
        text: 'Family & Ancestry',
        state: '',
        name: 'family&ancestry',
        ga4EventType: 'family_ancestry',
        childItems: [
          {
            route: '/family-tree',
            icon: <CustomIcons.FamilyTreeIcon sx={{ color: '#0052FF' }} />,
            text: 'Family Tree',
            state: '',
            name: 'familyTree',
            ga4EventType: 'family_tree',
          },
          {
            route: '/dashboard/family-insights',
            icon: <PieChartOutline sx={{ color: '#0052FF' }} />,
            text: 'Family Insights',
            state: '',
            name: 'familyInsights',
            ga4EventType: 'family_insights',
          },
          {
            route: '/dashboard/obituary',
            icon: <LocalFlorist sx={{ color: '#0052FF' }} />,
            text: 'Obituary Search',
            state: '',
            name: 'obituarySearch',
            ga4EventType: 'obituary',
          },
          {
            route: '/dashboard/name-history',
            icon: <LocalLibraryRounded />,
            text: 'Name History',
            state: '',
            name: 'nameHistory',
            ga4EventType: 'name_history',
          },
        ],
      },
      {
        route: '/dashboard/rewards',
        icon: <Redeem sx={{ color: '#0052FF' }} />,
        text: 'Member Perks',
        state: '',
        name: 'memberPerks',
        ga4EventType: 'member_perks',
      },
      {
        route: '/dashboard/monitoring',
        icon: <NotificationsNone sx={{ color: '#0052FF' }} />,
        text: 'Monitoring',
        state: '',
        name: 'monitoring',
        ga4EventType: 'monitoring',
      },
      {
        route: '/search/owner',
        icon: <PersonPinCircle sx={{ color: '#0052FF' }} />,
        text: 'Owner Search',
        state: '',
        name: 'owner_search',
        ga4EventType: 'owner_search',
      },
      {
        route: '/dashboard/my-garage',
        icon: <DirectionsCarRounded sx={{ color: '#0052FF' }} />,
        text: 'My Garage',
        state: '',
        name: 'myGarage',
        ga4EventType: 'my_garage',
      },
      {
        route: '/dashboard/neighborhood-report',
        icon: <MapRounded sx={{ color: '#0052FF' }} />,
        text: 'Neighborhood Report',
        state: '',
        name: 'neighborhoodReport',
        ga4EventType: 'neighborhood_report',
      },
      {
        route: '/search/contact?advancedSearch=true&source=contactSearch',
        icon: <Work sx={{ color: '#0052FF' }} />,
        text: 'Contact Pro',
        state: '',
        name: 'contactSearch',
        ga4EventType: 'contact_search',
      },
      {
        route: '/dashboard/billing',
        icon: <AccountCircle sx={{ color: '#0052FF' }} />,
        text: 'My Account',
        state: '',
        name: 'myAccount',
        'data-cy': 'my_account',
        ga4EventType: 'my_account',
      },

      {
        route: '/dashboard/referrals',
        icon: <PersonAdd sx={{ color: '#0052FF' }} />,
        text: 'Send Invite',
        state: '',
        name: 'referrals',
        ga4EventType: 'referrals',
      },
      {
        route: '/dashboard/plan-members',
        icon: <Groups sx={{ color: '#0052FF' }} />,
        text: 'Plan Members',
        state: '',
        name: 'planMembers',
        ga4EventType: 'plan_members',
      },
    ],
    reportTypeFilterOptions,
    higherConfidenceThreshold: 50,
    hardcodedPlans: [],
    useLLMPersonMaxRetries: 2,
  },
  keys: {
    rapidsAPIKey: import.meta.env.VITE_RAPIDS_API_KEY ?? '',
    mapboxKey: import.meta.env.VITE_MAPBOX_API_KEY ?? '',
    mrRogersAPIKey: import.meta.env.VITE_MR_ROGERS_API_KEY ?? '',
    streetViewStaticApiKey:
      import.meta.env.VITE_STREET_VIEW_STATIC_API_KEY ?? '',
    topHapApiKey: import.meta.env.VITE_TOP_HAP_API_KEY ?? '',
    astrologyUser: import.meta.env.VITE_ASTROLOGY_API_USER,
    astrologyKey: import.meta.env.VITE_ASTROLOGY_API_KEY,
    logoDev: import.meta.env.VITE_LOGO_DEV_PUBLIC_KEY ?? '',
  },
  paymentPremiumModalCardData: {
    premiumPlan:
      '36_79_1_month_nofree_afill_limit_100_freepdf_upsell_alldataaccess',
    premiumPlanAmount: '$36.79',
    premiumPlanReports: [
      'Person Reports',
      'Property Reports',
      'Username, Phone & Email Reports',
      'Dark Web Scan',
    ],
    currentPlanReports: [
      'VIN & License Plate Lookup',
      'Year, Make, Model Search',
    ],
    premiumMessage:
      'to unlock additional search options of names, phones, addresses & more!',
  },
  downsellModalCardData: {
    downsellPlan: '14_99_1_month_nofree_afill_limit25reports_freepdf_downsell',
    downsellPlanAmount: '14.99',
  },
  internationalSpanishPlanNames: [
    // Phone Only Signup Plans
    '7_day_trial_1_00_up_front_24_99_recurring_monthly_freshness_limit_100_no_pdf_phone_international_phone_only_spanish',
    '7_day_trial_5_00_up_front_24_99_recurring_monthly_freshness_limit_100_free_pdf_phone_international_phone_only_spanish',
    '5_00_1_month_nofree_afill_freshness_limit_20_freepdf_international_spanish',
    // Vehicle Only Signup Plans
    '7_day_trial_1_00_up_front_27_99_recurring_monthly_limit_100_no_pdf_vehicle_international_spanish',
    '7_day_trial_5_00_up_front_27_99_recurring_monthly_limit_100_free_pdf_vehicle_international_spanish',
    '5_00_1_month_nofree_afill_freshness_limit_20_freepdf_international_vehicle_only_spanish',
    'one_check_29_99_60day_renewal_limit_1_bv_international_vehicle_only_spanish',
  ],
  personalityTraitsColors: {
    radioButtonColors: ['#DC0015', '#EA6672', '#808080', '#90d393', '#388E3C'],
    radioButtonHoverColors: [
      '#f9d0d3',
      '#fbdfe1',
      '#d8d8d8',
      '#e4f4e5',
      '#bae4bc',
    ],
  },
  internationalPhoneInput: {
    enabled: true,
    utilsUrl: 'https://cdnx.beenverified.com/assets/js/utils.js',
    phoneSearchCountryCodes: internationalPhoneSearchLocale.countryCodes,
    phoneSearchPlaceholders: internationalPhoneSearchLocale.placeholders,
    phoneSearchPopularCountryCodes: internationalPhoneSearchPopularCountryCodes,
    phoneFraudSearchCountryCodes:
      internationalPhoneFraudSearchLocale.countryCodes,
    phoneFraudSearchPlaceholders:
      internationalPhoneFraudSearchLocale.placeholders,
    phoneFraudSearchPopularCountryCodes:
      internationalPhoneFraudSearchPopularCountryCodes,
  },
};

export const sideMenuItemsForNewDesign = (
  isInAstrologyStandaloneVariation: boolean,
  isSeatManager = false
) => {
  const recentReportsItem: SideMenuItem = {
    route: '/dashboard/reports',
    icon: <Restore sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Recent Reports',
    name: 'recentReports',
    state: '',
    'data-cy': 'recent_reports',
  };

  const savedReportsItem: SideMenuItem = {
    route: '/dashboard/lists',
    icon: <List sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Saved Reports and Lists',
    state: '',
    name: 'lists',
    'data-cy': 'saved_reports_and_list',
  };

  const myGarageItem: SideMenuItem = {
    route: '/dashboard/my-garage',
    icon: <DirectionsCarRounded sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'My Garage',
    state: '',
    name: 'myGarage',
  };

  const contactProItem: SideMenuItem = {
    route: '/search/contact?advancedSearch=true&source=contactSearch',
    icon: <Work sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Contact Pro',
    state: '',
    name: 'contactSearch',
  };

  const contactEnrichmentItem: SideMenuItem = {
    route: '/dashboard/contact-enrichment',
    icon: <RecentActors sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Contact Enrichment',
    state: '',
    name: 'contactEnrichment',
    isLocked: false,
    ga4EventType: 'contact_enrichment',
  };

  const bulkPropertySearchItem: SideMenuItem = {
    route: '/dashboard/import-list',
    icon: <FindInPage sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Bulk Property Search',
    state: '',
    name: 'bulkPropertySearch',
    ga4EventType: 'bulk_property_search',
  };

  const apiItem: SideMenuItem = {
    route: '/dashboard/api',
    icon: <Code sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'API',
    state: '',
    name: 'bvApi',
    ga4EventType: 'bv_api',
  };

  const professionalToolsItem: SideMenuItem = {
    route: '',
    icon: <Business sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Professional Tools',
    state: '',
    name: 'professional-tools',
    childItems: [bulkPropertySearchItem, contactEnrichmentItem, apiItem],
  };

  const emailSearchItem: SideMenuItem = {
    route: '/dashboard/email-search',
    icon: (
      <CustomIcons.AttachEmailOutlined
        color="primary"
        sx={{ fontSize: '24px' }}
      />
    ),
    text: 'Email Search',
    state: '',
    name: 'emailSearch',
  };

  const unclaimedMoneyItem: SideMenuItem = {
    route: '/dashboard/unclaimed-money',
    icon: <AttachMoney sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Unclaimed Money',
    state: '',
    name: 'unclaimedMoney',
    'data-cy': 'unclaimed_money',
  };

  const legalIntelligenceItem: SideMenuItem = {
    route: LEGAL_INTELLIGENCE_ROUTES.BASE,
    icon: <Gavel sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: (
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        Legal Intelligence
        <PillList items={[{ label: 'New' }]} />
      </Stack>
    ),
    state: '',
    name: 'legalIntelligence',
  };

  const fraudScanItem: SideMenuItem = {
    route: '/dashboard/fraud',
    icon: <Radar sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: (
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        FraudScan
        <PillList items={[{ label: 'New' }]} />
      </Stack>
    ),
    state: '',
    name: 'fraudScan',
  };

  const neighborhoodSearchItem: SideMenuItem = {
    route: '/dashboard/neighborhood-report',
    icon: <MapRounded sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Neighborhood Search',
    state: '',
    name: 'neighborhoodSearch',
  };

  const homesForSaleItem: SideMenuItem = {
    route: '/homes-for-sale',
    icon: <SellOutlined sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Homes For Sale',
    state: '',
    name: 'homesForSale',
  };

  const shortTermRentalsItem: SideMenuItem = {
    route: '/short-term-rental',
    icon: <NightShelter sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Short-Term Rentals',
    state: '',
    name: 'shortTermRentals',
  };

  const additionalPropertySearchesItem: SideMenuItem = {
    route: '',
    icon: <Cottage sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: (
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        More Property Searches
        <PillList items={[{ label: 'New' }]} />
      </Stack>
    ),
    state: '',
    name: 'additionalPropertySearches',
    childItems: [
      homesForSaleItem,
      shortTermRentalsItem,
      neighborhoodSearchItem,
    ],
  };

  const personalityTraitsItem: SideMenuItem = {
    route: '/dashboard/personality-traits',
    icon: <Psychology sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: (
      <Stack
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        fontSize="1.125rem"
      >
        Personality Traits
        <PillList items={[{ label: 'New' }]} />
      </Stack>
    ),
    state: '',
    name: 'personalityTraits',
    'data-cy': 'personality_traits',
  };

  const astrologyItem: SideMenuItem = {
    route: '/dashboard/astrology',
    icon: <FlareRounded color="primary" />,
    text: (
      <Stack
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        fontSize="1.125rem"
      >
        Astrology
        <PillList items={[{ label: 'New' }]} />
      </Stack>
    ),
    state: '',
    name: 'astrology',
    'data-cy': 'astrology',
  };

  const familyDashboardItem: SideMenuItem = {
    route: '/dashboard/family-ancestry',
    icon: (
      <CustomIcons.FamilyTreeAncestryIcon
        color="primary"
        sx={{ fontSize: '24px' }}
      />
    ),
    text: 'Family Dashboard',
    state: '',
    name: 'family-dashboard',
  };

  const familyTreeItem: SideMenuItem = {
    route: '/family-tree',
    icon: (
      <CustomIcons.FamilyTreeIcon color="primary" sx={{ fontSize: '24px' }} />
    ),
    text: 'Family Tree',
    state: '',
    name: 'familyTree',
  };

  const familyMapItem: SideMenuItem = {
    route: '/family-map',
    icon: <MapRounded sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Family Map',
    state: '',
    name: 'familyMap',
  };

  const familyInsightsItem: SideMenuItem = {
    route: '/dashboard/family-insights',
    icon: <PieChartOutline sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Family Insights',
    state: '',
    name: 'familyInsights',
  };

  const obituarySearchItem: SideMenuItem = {
    route: '/dashboard/obituary',
    icon: <LocalFlorist sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Obituary Search',
    state: '',
    name: 'obituarySearch',
  };

  const nameHistoryItem: SideMenuItem = {
    route: '/dashboard/name-history',
    icon: <LocalLibraryRounded sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Name History',
    state: '',
    name: 'nameHistory',
  };

  const darkWebItem: SideMenuItem = {
    route: '/dashboard/dark-web',
    icon: <CustomIcons.DarkWebIcon color="primary" sx={{ fontSize: '24px' }} />,
    text: 'Dark Web',
    state: '',
    name: 'darkWebScan',
    'data-cy': 'dark_web_scan',
  };

  const myAccountItem: SideMenuItem = {
    route: '/dashboard/billing',
    icon: <AccountCircle sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'My Account',
    state: '',
    name: 'myAccount',
    'data-cy': 'my_account',
  };

  const memberPerksItem: SideMenuItem = {
    route: '/dashboard/rewards',
    icon: <Redeem sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Member Perks',
    state: '',
    name: 'memberPerks',
  };

  const sendInviteItem: SideMenuItem = {
    route: '/dashboard/referrals',
    icon: <PersonAdd sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Send Invite',
    state: '',
    name: 'referrals',
  };

  const planMembersItem: SideMenuItem = {
    route: '/dashboard/plan-members',
    icon: <Groups sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Plan Members',
    state: '',
    name: 'planMembers',
  };

  const dashboardItem: SideMenuItem = {
    route: '/dashboard',
    icon: <Home sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'My Dashboard',
    name: 'dashboard',
    state: '',
    'data-cy': 'dashboard',
  };

  const reportsItem: SideMenuItem = {
    route: '',
    icon: <Summarize sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Reports',
    name: 'reports',
    state: '',
    'data-cy': 'reports',
    childItems: [recentReportsItem, savedReportsItem, myGarageItem],
  };

  const deepSearchItem: SideMenuItem = {
    route: '/deepsearch',
    icon: <AutoAwesomeRounded sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: (
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        Deep Search
        <PillList items={[{ label: 'New' }]} />
      </Stack>
    ),
    name: 'chat-ai',
    state: '',
  };

  const mySavedSearchesItem: SideMenuItem = {
    route: '/dashboard/my-saved-searches',
    icon: <FindInPageOutlined sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'My Saved Searches',
    state: '',
    name: 'mySavedSearches',
    'data-cy': 'my_saved_searches',
  };

  const moreSearchesItem: SideMenuItem = {
    route: '',
    icon: <Search sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: (
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        More Searches
        <PillList items={[{ label: 'New' }]} />
      </Stack>
    ),
    state: '',
    name: 'more-searches',
    childItems: [
      deepSearchItem,
      unclaimedMoneyItem,
      fraudScanItem,
      additionalPropertySearchesItem,
      emailSearchItem,
      contactProItem,
      legalIntelligenceItem,
      mySavedSearchesItem,
    ],
  };

  const familyAncestryItem: SideMenuItem = {
    route: '/dashboard/family-ancestry',
    icon: <FamilyRestroom sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Family & Ancestry',
    state: '',
    name: 'family&ancestry',
    childItems: [
      familyDashboardItem,
      familyInsightsItem,
      familyTreeItem,
      obituarySearchItem,
      nameHistoryItem,
    ],
  };

  const digitalFootprintItem: SideMenuItem = {
    route: '/dashboard/digital-footprint',
    icon: (
      <CustomIcons.DigitalFootprintIcon
        color="primary"
        sx={{ fontSize: '24px' }}
      />
    ),
    text: 'Digital Footprint',
    state: '',
    name: 'digitalfootprint',
  };

  const monitoringAndAlertsItem: SideMenuItem = {
    route: '/dashboard/monitoring',
    icon: <Notifications sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Monitoring & Alerts',
    state: '',
    name: 'monitoringAndAlerts',
  };

  const myProfileItem: SideMenuItem = {
    route: '',
    icon: <ManageAccounts sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'My Account',
    state: '',
    name: 'my-account',
    childItems: [myAccountItem, memberPerksItem, sendInviteItem],
  };

  const items: SideMenuItem[] = [
    dashboardItem,
    {
      ...reportsItem,
      childItems: [recentReportsItem, monitoringAndAlertsItem],
    },
    {
      ...moreSearchesItem,
      childItems: [
        deepSearchItem,
        unclaimedMoneyItem,
        contactProItem,
        { ...darkWebItem, text: 'Dark Web Scan' },
        { ...myGarageItem, text: 'Vehicle Search' },
        additionalPropertySearchesItem,
        emailSearchItem,
        fraudScanItem,
        legalIntelligenceItem,
      ],
    },
    {
      ...familyAncestryItem,
      text: 'Family & Ancestry',
      childItems: [
        familyDashboardItem,
        familyTreeItem,
        familyInsightsItem,
        familyMapItem,
        obituarySearchItem,
        nameHistoryItem,
      ],
    },
    professionalToolsItem,
    {
      ...myProfileItem,
      childItems: [
        myAccountItem,
        memberPerksItem,
        digitalFootprintItem,
        personalityTraitsItem,
        ...(isInAstrologyStandaloneVariation ? [astrologyItem] : []),
        ...(isSeatManager ? [planMembersItem] : []),
        sendInviteItem,
      ],
    },
  ];

  return items;
};

export const internationalSideMenuItems = [
  {
    route: '',
    icon: <Summarize sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Reports',
    name: 'reports',
    state: '',
    'data-cy': 'reports',
    childItems: [
      {
        route: '/dashboard/reports',
        icon: <Restore sx={{ fontSize: '24px', color: '#0052FF' }} />,
        text: 'Recent Reports',
        name: 'recentReports',
        state: '',
        'data-cy': 'recent_reports',
      },
      {
        route: '/dashboard/lists',
        icon: <List sx={{ fontSize: '24px', color: '#0052FF' }} />,
        text: 'Saved Reports and Lists',
        state: '',
        name: 'lists',
        'data-cy': 'saved_reports_and_list',
      },
      {
        route: '/dashboard/my-garage',
        icon: (
          <DirectionsCarRounded color="primary" sx={{ fontSize: '24px' }} />
        ),
        text: 'My Garage',
        state: '',
        name: 'myGarage',
      },
    ],
  },
  {
    route: '',
    icon: <Lightbulb sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Personal Growth',
    name: 'personal-growth',
    state: '',
    'data-cy': 'personal-growth',
  },
  {
    route: '',
    icon: <NotificationsActive sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Monitoring Hub',
    state: '',
    name: 'monitoring-hub',
    childItems: [
      {
        route: '/dashboard/monitoring',
        icon: <NotificationsNone sx={{ fontSize: '24px', color: '#0052FF' }} />,
        text: 'Monitoring',
        state: '',
        name: 'monitoring',
      },
    ],
  },
  {
    route: '',
    icon: <ManageAccounts sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'My Account',
    state: '',
    name: 'my-account',
    childItems: [
      {
        route: '/dashboard/billing',
        icon: <AccountCircle sx={{ fontSize: '24px', color: '#0052FF' }} />,
        text: 'My Account',
        state: '',
        name: 'myAccount',
        'data-cy': 'my_account',
      },
    ],
  },
];
